import Component from "@glimmer/component";
import { fn } from "@ember/helper";
import { on } from "@ember/modifier";
import { action } from "@ember/object";
import { modifier as modifierFn } from "ember-modifier";
import dConcatClass from "discourse/ui-kit/helpers/d-concat-class";
import dIcon from "discourse/ui-kit/helpers/d-icon";
import { i18n } from "discourse-i18n";

export default class DSegmentedControl extends Component {
  positionSlider = modifierFn((element, [value]) => {
    if (!value) {
      return;
    }

    const checked = element.querySelector("input:checked");
    if (!checked) {
      return;
    }

    const slider = element.querySelector(".d-segmented-control__slider");
    const label = checked.closest(".d-segmented-control__label");
    const frameId = requestAnimationFrame(() => {
      element.style.setProperty("--slider-x", `${label.offsetLeft}px`);
      element.style.setProperty("--slider-width", `${label.offsetWidth}px`);

      if (!slider.classList.contains("is-animated")) {
        requestAnimationFrame(() => slider.classList.add("is-animated"));
      }
    });

    return () => cancelAnimationFrame(frameId);
  });

  get classNames() {
    const classes = ["d-segmented-control"];
    if (this.args.size === "small") {
      classes.push("d-segmented-control--small");
    }
    return classes.join(" ");
  }

  get legend() {
    if (this.args.label) {
      return i18n(this.args.label);
    }
    return this.args.translatedLabel;
  }

  @action
  handleChange(value) {
    this.args.onSelect?.(value);
  }

  @action
  handleClick(value) {
    this.args.onClickItem?.(value);
  }

  <template>
    <fieldset
      class={{this.classNames}}
      ...attributes
      {{this.positionSlider @value}}
    >
      {{#if this.legend}}
        <legend class="d-segmented-control__legend">
          {{this.legend}}
        </legend>
      {{/if}}

      <span class="d-segmented-control__slider"></span>

      {{#each @items as |item|}}
        <label
          class={{dConcatClass
            "d-segmented-control__label"
            item.class
            (if item.disabled "is-disabled")
          }}
          {{on "click" (fn this.handleClick item.value)}}
        >
          <input
            checked={{eq @value item.value}}
            class="d-segmented-control__input"
            disabled={{item.disabled}}
            name={{@name}}
            type="radio"
            value={{item.value}}
            {{on "change" (fn this.handleChange item.value)}}
          />
          <span class="d-segmented-control__text">
            {{#if item.icon}}{{dIcon item.icon}}{{/if}}
            {{item.label}}
          </span>
        </label>
      {{/each}}
    </fieldset>
  </template>
}
